export default __webpack_public_path__ + "static/media/CableAV.86caf18d.png";